export default __webpack_public_path__ + "static/media/it-losses.309e6b30.svg";